import "./DesktopMonetizeSteps.css";
import { useLang } from "../../../../i18n/LangContext";
import stepsImage from "../../../../assets/desktopMonetize/steps/steps.png";

export default function DesktopMonetizeSteps({ id = "steps" }) {
  const { t } = useLang();
  const data = t?.monetizeSteps;
  if (!data) return null;

  return (
    <section id={id} className="mon-steps-root" aria-label="How it works">
      <div className="mon-steps-wrap">
        <header className="mon-steps-head">
          <p className="mon-steps-eyebrow">{data.eyebrow}</p>
          <h2 className="mon-steps-title">
            {data.titleLine1}<br />{data.titleLine2}
          </h2>
        </header>

        <div className="mon-steps-image">
          <img src={stepsImage} alt="Steps flow" loading="lazy" />
        </div>
      </div>
    </section>
  );
}
